import { boolean, object, string } from "yup";
import { StatusEnum } from "../../shared";

export const DEFAULT_VALUES = {
  damagedGoodsWarehouse: false,
  status: StatusEnum.ACTIVE,
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  damagedGoodsWarehouse: boolean().required("Harus diisi"),
  status: boolean().required("Harus diisi"),
});
